<mat-expansion-panel
  class="survey-section-question-edit"
  [expanded]="question_form().controls.expanded.value"
  (opened)="setExpanded(true)"
  (closed)="setExpanded(false)"
  togglePosition="before"
>
  <mat-expansion-panel-header>
    <mat-panel-title class="survey-section-question-edit__title">
      <button
        class="survey-section-question-edit__drag"
        type="button"
        cdkDragHandle
        [disabled]="disabled()"
        aria-label="Reordenar pregunta"
        (click)="$event.stopPropagation()"
      >
        <mat-icon>drag_indicator</mat-icon>
      </button>
      <span class="survey-section-question-edit__title-text" [attr.title]="header_title()">{{ header_title() }}</span>
    </mat-panel-title>

    <mat-panel-description class="survey-section-question-edit__header-actions">
      <button
        class="survey-section-question-edit__delete"
        mat-icon-button
        type="button"
        aria-label="Eliminar pregunta"
        [disabled]="disabled()"
        (click)="$event.stopPropagation(); remove.emit()"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div [formGroup]="question_form()" class="survey-section-question-edit__fields">
    <mat-form-field appearance="outline" class="full-width survey-section-question-edit__statement">
      <mat-label>Enunciado</mat-label>
      <input matInput formControlName="statement" />

      @if (question_form().controls.statement.hasError('required')) {
        <mat-error>El enunciado es obligatorio</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width survey-section-question-edit__type">
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="type" (selectionChange)="onQuestionTypeChange($event.value)">
        @for (question_type_option of question_type_options; track question_type_option.value) {
          <mat-option [value]="question_type_option.value">{{ question_type_option.label }}</mat-option>
        }
      </mat-select>

      @if (question_form().controls.type.hasError('required')) {
        <mat-error>El tipo es obligatorio</mat-error>
      }
    </mat-form-field>

    @if (is_text_question()) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Mínimo de caracteres</mat-label>
        <input
          matInput
          type="number"
          formControlName="min_characters"
          [min]="text_min_characters_min"
          [max]="text_min_characters_max"
          step="1"
        />
        @if (question_form().controls.min_characters.hasError('required')) {
          <mat-error>El mínimo de caracteres es obligatorio</mat-error>
        } @else if (question_form().controls.min_characters.hasError('max')) {
          <mat-error>El mínimo de caracteres no puede superar {{ text_min_characters_max }}</mat-error>
        } @else if (question_form().controls.min_characters.invalid) {
          <mat-error>Introduce un número entero entre {{ text_min_characters_min }} y {{ text_min_characters_max }}</mat-error>
        }
      </mat-form-field>
    }

    @if (show_editable_response_options()) {
      <div class="survey-section-question-edit__items" formArrayName="items">
        <div class="survey-section-question-edit__items-header">
          <h4 class="survey-section-question-edit__items-title">Opciones de respuesta</h4>
          <button mat-stroked-button type="button" (click)="addItem()">
            <mat-icon>add</mat-icon>
            Añadir opción
          </button>
        </div>

        <div class="survey-section-question-edit__items-list" cdkDropList (cdkDropListDropped)="dropItem($event)">
          @for (item_form of question_form().controls.items.controls; track item_form; let item_index = $index) {
            <div class="survey-section-question-edit__item" cdkDrag [formGroupName]="item_index">
              <button class="survey-section-question-edit__item-drag" type="button" cdkDragHandle aria-label="Reordenar opción">
                <mat-icon>drag_indicator</mat-icon>
              </button>

              <div class="survey-section-question-edit__item-fields">
                <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                  <mat-label>Opción {{ item_index + 1 }}</mat-label>
                  <input matInput formControlName="statement" />
                  @if (item_form.controls.statement.hasError('required')) {
                    <mat-error>El texto de la opción es obligatorio</mat-error>
                  }
                </mat-form-field>

                <mat-form-field
                  appearance="outline"
                  class="full-width survey-section-question-edit__item-description"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Descripción (opcional)</mat-label>
                  <textarea matInput formControlName="description" rows="2"></textarea>
                </mat-form-field>
              </div>

              <button
                class="survey-section-question-edit__item-delete"
                mat-icon-button
                type="button"
                aria-label="Eliminar opción"
                [disabled]="question_form().controls.items.length <= 2"
                (click)="$event.stopPropagation(); removeItem(item_index)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }

    <div class="survey-section-question-edit__settings">
      <div class="survey-section-question-edit__options">
        <mat-checkbox formControlName="is_required">Obligatoria</mat-checkbox>
        <mat-checkbox formControlName="allows_dont_know">Permitir "No lo sé"</mat-checkbox>
      </div>

      <mat-form-field appearance="outline" class="full-width survey-section-question-edit__anonymous-scope">
        <mat-label>Quién puede ver qué usuario ha respondido</mat-label>
        <mat-select formControlName="anonymous_scope">
          @for (anonymous_scope_option of anonymous_scope_options; track anonymous_scope_option.value) {
            <mat-option [value]="anonymous_scope_option.value">{{ anonymous_scope_option.label }}</mat-option>
          }
        </mat-select>
        @if (question_form().controls.anonymous_scope.hasError('required')) {
          <mat-error>La opción de anonimato es obligatoria</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</mat-expansion-panel>
